import { stringsKeys as stringsKeysOfFSC } from '@skyscanner-internal/global-components/flights-search-controls/common/constants/translationsStringsKeys';
import { STRING_KEYS as stringKeysOfFSS } from '@skyscanner-internal/global-components/flights-search-summary/common/constants';

export const TRANSLATION_KEYS = {
  flightsSearchControls: stringsKeysOfFSC,
  flightsSearchSummary: stringKeysOfFSS,
};

// All translation keys of Global Component
export const translationKeysOfGC = [
  // We can import other GCs here in the future, so they could follow the same standard of translation way
  ...TRANSLATION_KEYS.flightsSearchControls,
  ...TRANSLATION_KEYS.flightsSearchSummary,
];

export type TranslationKeyOfGC = (typeof translationKeysOfGC)[number];
